import { Container } from 'pixi.js';
import { BOOSTER_LIST } from '../../../Config/Items';
import Core, { GameOrientation } from '../../../Core/Core';
import { BoosterId } from '../../../State/reducers/boosters';
import { BoosterButton } from './BoosterButton';

interface IButtons {
    [key: string]: BoosterButton;
}

export class GameBoosters extends Container {
    public buttonList: string[];
    private readonly buttons: IButtons;

    constructor(cb: (id: string) => void, currentBoosters: string[], bg: PIXI.Sprite) {
        super();

        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;

        const buttonList = BOOSTER_LIST;
        const spacing = isPortrait
            ? (bg.width * 0.85) / buttonList.length
            : (bg.height * 0.77) / buttonList.length;

        this.buttons = {};
        buttonList.forEach((id, i) => {
            const newButton = new BoosterButton(id, currentBoosters.indexOf(id) !== -1);

            newButton.x = isPortrait ? bg.width * 0.13 + spacing * i : bg.width * 0.5;
            newButton.y = isPortrait
                ? bg.height - newButton.height / 1.8
                : bg.height * 0.22 + spacing * i;
            this.addChild(newButton);
            newButton.interactive = true;
            newButton.on('trigger', () => {
                cb(id);
            });

            this.buttons[id] = newButton;
        });
        this.buttonList = buttonList;
    }

    public getButton(id: string): BoosterButton {
        const buttonIndex = this.buttonList.indexOf(id);
        if (buttonIndex === -1) {
            return null;
        }
        return this.getChildAt(buttonIndex) as BoosterButton;
    }

    public showAvailable(available: string[], free: string[]) {
        Object.values(this.buttons).forEach(b => {
            const n = available.filter(a => a === b.boosterId).length;
            const freeNum = free.filter(f => f === b.boosterId).length;
            b.showQuantity(n, freeNum > 0);
        });
    }

    public lockBooster(id: string, lock: boolean) {
        const button = this.getButton(id);
        if (button) {
            button.setLocked(lock);
        }
    }

    public setCallAttention(attention: boolean, boosterIds: BoosterId[]) {
        for (const buttonsKey of boosterIds) {
            const button = this.buttons[buttonsKey];
            if (attention) {
                button.callAttention();
            } else {
                button.stopAttention();
            }
        }
    }
}
